module.exports = __webpack_public_path__ + "static/img/10006C_3_4_R_20190901_LC.3012c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10006C_3_4_R_20190901_LC.png
// module id = hnii
// module chunks = 0